/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { API } from './apiutil';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SystemMessagingService {
    http;
    constructor(http) {
        this.http = http;
    }
    getSystemMessages(ctx) {
        return this.http.get(`${environment.base}/messaging`, { params: API.makeParams(ctx) });
    }
    static ɵfac = function SystemMessagingService_Factory(t) { return new (t || SystemMessagingService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SystemMessagingService, factory: SystemMessagingService.ɵfac });
}
